
<template>
  <div class="bread-box" v-if="metaList.length > 0">
    <el-breadcrumb separator=">">
      <el-breadcrumb-item v-for="(item,index) in metaList" :key='item.name' :to="item.path" >{{item.name}}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>

</template>

<script>
  export default {
    data() {
      return {
        btnShow:false,
        metaList: this.$route.meta
      }
    },
    created(){

    },
    watch:{
      '$route'(to,from){
        this.metaList = this.$route.meta
        
      }
    },
    methods:{
     
    }

  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .sort-btn{
    position: absolute;
    right: 20px;
    top: 8px;
  }
</style>
